import { SingleSampleFlowState } from 'cards/reducers/singleSampleFlow/reducer';
import { RootState } from 'reducers/index';
import { createSelector } from 'reselect';

export const getFlowData = (state: RootState): SingleSampleFlowState =>
  state.cards.singleSampleFlow;

export const getAllLPOrFoil = createSelector(getFlowData, flowData => flowData.allLPOrFoil);

export const getCardSuiteDetailsSet = createSelector(
  getFlowData,
  flowData => flowData.cardSuiteDetailsSet
);

export const getCardType = createSelector(getFlowData, flowData => flowData.cardType);

export const getCustomizationsSet = createSelector(
  getFlowData,
  flowData => flowData.customizationsSet
);

export const getCustomizeData = createSelector(getFlowData, flowData => flowData.customize);

export const getErrors = createSelector(getFlowData, flowData => flowData.errors);

export const getHasLPOrFoil = createSelector(getFlowData, flowData => flowData.hasLPOrFoil);

export const getNamesData = createSelector(getFlowData, flowData => flowData.names);

export const getOrderNumber = createSelector(getFlowData, flowData => flowData.orderNumber);

export const getShippingDataFetched = createSelector(
  getFlowData,
  flowData => flowData.shipping.fetched
);

export const getSingleSampleAvailable = createSelector(
  getFlowData,
  flowData => flowData.singleSampleAvailable
);

export const getShippingData = createSelector(getFlowData, flowData => flowData.shipping);

export const getSilhouette = createSelector(
  getFlowData,
  flowData => flowData.customize.activeSelections.silhouette
);

export const getStepKey = createSelector(getFlowData, flowData => flowData.stepKey);

export const getTemplatesSet = createSelector(getFlowData, flowData => flowData.templatesSet);
